export default __webpack_public_path__ + "static/media/editingIcon.1349ba30.png";